"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SigHelperMock__factory = void 0;

var _ethers = require("ethers");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const _abi = [{
  inputs: [{
    internalType: "string",
    name: "name",
    type: "string"
  }],
  stateMutability: "nonpayable",
  type: "constructor"
}, {
  inputs: [],
  name: "SignatureAlreadyCancelled",
  type: "error"
}, {
  inputs: [],
  name: "DOMAIN_SEPARATOR",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "string",
    name: "name",
    type: "string"
  }, {
    internalType: "string",
    name: "version",
    type: "string"
  }],
  name: "__SigHelper_initInternal",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "hash",
    type: "bytes32"
  }],
  name: "cancelHashInternal",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  name: "cancelled",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  name: "nonces",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "hash",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "signer",
    type: "address"
  }, {
    components: [{
      internalType: "bytes32",
      name: "r",
      type: "bytes32"
    }, {
      internalType: "bytes32",
      name: "s",
      type: "bytes32"
    }, {
      internalType: "uint8",
      name: "v",
      type: "uint8"
    }],
    internalType: "struct SigHelper.Sig",
    name: "sig",
    type: "tuple"
  }],
  name: "validateSigInternal",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}];
const _bytecode = "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";

const isSuperArgs = xs => xs.length > 1;

class SigHelperMock__factory extends _ethers.ContractFactory {
  constructor(...args) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(name, overrides) {
    return super.deploy(name, overrides || {});
  }

  getDeployTransaction(name, overrides) {
    return super.getDeployTransaction(name, overrides || {});
  }

  attach(address) {
    return super.attach(address);
  }

  connect(signer) {
    return super.connect(signer);
  }

  static createInterface() {
    return new _ethers.utils.Interface(_abi);
  }

  static connect(address, signerOrProvider) {
    return new _ethers.Contract(address, _abi, signerOrProvider);
  }

}

exports.SigHelperMock__factory = SigHelperMock__factory;

_defineProperty(SigHelperMock__factory, "bytecode", _bytecode);

_defineProperty(SigHelperMock__factory, "abi", _abi);